import React from 'react';
import { Input, Select, Radio, DatePicker, Col, Row, Icon } from 'antd';
import moment from 'moment';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';


const { Option } = Select;

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>

                    {/*           <Col className="gutter-row" sm={24} md={12} lg={9}>

                        <Select 
                            showSearch 
                            labelInValue
                            value={
                                this.props.filter.idEntidad ?
                                    { key: this.props.filter.idEntidad } : undefined
                            }
                            placeholder={"Seleccione Entidad"}
                            optionFilterProp="children"
                            className="second-input"
                            onChange={(option) => this.props.onChange('idEntidad', option.key)}
                        >
                            {this.props.entidades.map(item => (
                                <Option key={item.id} value={item.id}>{item.razonSocial}</Option>
                            ))}
                        </Select>



                    </Col> */}
                    <Col className="gutter-row" sm={24} md={12} lg={9}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.entidad}
                            onChange={(e) => this.props.onChange("entidad", e.target.value)}
                            placeholder="Filtrar por entidad, Ruc"
                            autoComplete="off"
                            onKeyUp={this.props.onKeyUpSearch}

                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch
                            labelInValue
                            value={
                                this.props.filter.idEstablecimiento ?
                                    { key: this.props.filter.idEstablecimiento } : undefined
                            }
                            placeholder={"Seleccione Almacen"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idEstablecimiento', option.key)}

                        >
                            {this.props.almacenes.map(item => (
                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                            ))}
                        </Select>
                    </Col>



                    <Col className="gutter-row" sm={24} md={12} lg={4}>

                        <Select
                            showSearch
                            labelInValue
                            value={
                                this.props.filter.idEstado ?
                                    { key: this.props.filter.idEstado } : undefined
                            }
                            placeholder={"Seleccione Estado"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idEstado', option.key)}
                        >
                            {this.props.estados.map(item => (
                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                            ))}
                        </Select>

                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch
                            labelInValue
                            value={
                                this.props.filter.idConcepto ?
                                    { key: this.props.filter.idConcepto } : undefined
                            }
                            placeholder={"Seleccione Concepto"}
                            optionFilterProp="children"
                            onChange={(option) => {
                                this.props.onChange("idConcepto", option.key)
                            }}
                        >
                            {this.props.conceptos.map(item => (
                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                            ))}
                        </Select>
                    </Col>


                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idProyecto ?
                                    { key: this.props.filter.idProyecto } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Proyecto" />}
                            onChange={(option) => this.props.onChange("idProyecto", option.key, option, 'proyecto')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.proyectos.map(item => ( //STATE DATA

                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>

                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={24} lg={4}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                            <Radio.Group
                                value={this.props.filter.tipoReporte}
                                onChange={(e) => this.props.onChange("tipoReporte", e.target.value)}
                            >
                                <Radio value={1}>Resumen</Radio>
                                <Radio value={2}>Detallado</Radio>
                            </Radio.Group>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters;